import { MembershipRole } from '@/types/api/membership';

export const roleNameMapping = {
  [MembershipRole.Leader]: 'Ledare',
  [MembershipRole.Member]: 'Deltagare',
};

export const roleNameColorMapping = {
  [MembershipRole.Member]: 'text-blue-500',
  [MembershipRole.Leader]: 'text-red-500',
};

export const roleBackgroundColorMapping = {
  [MembershipRole.Member]: 'bg-blue-500/20 text-blue-700',
  [MembershipRole.Leader]: 'bg-red-500/20 text-red-700',
};
